import { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TypewriterText } from "@features/tools/components/imagen/TypewriterText";
import { CustomBubble } from "@features/tools/components/imagen/CustomBubble";

interface ThinkingBubbleProps {
  /** Custom thinking messages to display. If not provided, will use default imagen messages */
  messages?: string[];
  /** Speed of the typewriter effect */
  speed?: number;
  /** Additional CSS classes for the text */
  textClassName?: string;
  /** Whether to show cursor in typewriter effect */
  showCursor?: boolean;
}

export const ThinkingBubble = memo<ThinkingBubbleProps>(
  ({
    messages,
    speed = 40,
    textClassName = "mb-6 text-xl sm:text-2xl text-gray-500",
    showCursor = false,
  }) => {
    const { t } = useTranslation();

    const thinkingMessages = useMemo(() => {
      if (messages) {
        return messages;
      }

      return [
        t("imagen.thinkingMessage1"),
        t("imagen.thinkingMessage2"),
        t("imagen.thinkingMessage3"),
        t("imagen.thinkingMessage4"),
      ];
    }, [t, messages]);

    return (
      <CustomBubble>
        <div className="flex justify-center text-center w-full px-4 sm:px-8 md:px-12 h-24">
          <TypewriterText
            text={thinkingMessages}
            speed={speed}
            className={textClassName}
            cursor={showCursor}
          />
        </div>
      </CustomBubble>
    );
  },
);

ThinkingBubble.displayName = "ThinkingBubble";

export default ThinkingBubble;
